import { Card, Group, Text } from "@mantine/core";
import type { ReactNode } from "react";

/** A titled card (the title is text, not a heading: pages keep one heading each). */
export function Section({
  title,
  actions,
  children,
  padding = "lg",
  testId,
}: {
  title?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
  padding?: "xs" | "sm" | "md" | "lg";
  testId?: string;
}) {
  return (
    <Card padding={padding} data-testid={testId}>
      {(title !== undefined || actions !== undefined) && (
        <Group justify="space-between" align="center" mb="sm" wrap="nowrap" gap="sm">
          {typeof title === "string" ? (
            <Text fw={600} size="sm">
              {title}
            </Text>
          ) : (
            title
          )}
          {actions}
        </Group>
      )}
      {children}
    </Card>
  );
}

/**
 * A table in a card: the header row, a horizontally scrollable body (a keyboard-reachable region,
 * so wide tables stay usable), and an optional footer.
 */
export function TableCard({
  title,
  actions,
  footer,
  children,
}: {
  title: string;
  actions?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card padding={0}>
      <Group justify="space-between" align="center" px="lg" py="sm" wrap="nowrap" gap="sm">
        <Text fw={600} size="sm">
          {title}
        </Text>
        {actions}
      </Group>
      <div className="sv-scroll" role="region" aria-label={title} tabIndex={0}>
        {children}
      </div>
      {footer !== undefined && (
        <Group px="lg" py="xs" justify="space-between">
          {footer}
        </Group>
      )}
    </Card>
  );
}
